module.exports = __webpack_public_path__ + "static/media/practice_time_integration.f7075780.svg";